import { render } from "./AdminDeliverability.vue?vue&type=template&id=7ff025c6&scoped=true"
import script from "./AdminDeliverability.vue?vue&type=script&lang=js"
export * from "./AdminDeliverability.vue?vue&type=script&lang=js"

import "./AdminDeliverability.vue?vue&type=style&index=0&id=7ff025c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ff025c6"]])

export default __exports__